export default "__VITE_ASSET__CPkqkFC___"